module.exports = __webpack_public_path__ + "static/bsas018-9ad40f3aa2dd4772d353951900e23f89.jpg";